import { useState } from "react";
import api from "../../api";
import { buildTree, nodesForPhase } from "./util";
import WorkplanList from "./WorkplanList";
import WorkplanBoard from "./WorkplanBoard";
import WorkplanOwner from "./WorkplanOwner";
import WorkplanTimeline from "./WorkplanTimeline";

const VIEWS = [
  { key: "list", label: "List", icon: "≣" },
  { key: "board", label: "Kanban", icon: "▤" },
  { key: "owner", label: "By owner", icon: "◫" },
  { key: "timeline", label: "Timeline", icon: "▭" },
];

export default function Workplan({ state, setState, isAdmin, phaseId = 2, weeks = 12 }) {
  const [view, setView] = useState("list");
  const all = state.workplan || [];
  const nodes = nodesForPhase(all, phaseId);
  const tree = buildTree(nodes);

  // Optimistic status update -> PATCH /workplan/{id}; reconcile on response.
  const onStatus = async (id, status) => {
    const prev = all;
    const optimistic = all.map((n) => (n.id === id ? { ...n, status } : n));
    setState({ ...state, workplan: optimistic });
    try {
      const { data } = await api.patch(`/workplan/${id}`, { status });
      setState({ ...state, workplan: all.map((n) => (n.id === id ? { ...n, ...data } : n)) });
    } catch (e) {
      setState({ ...state, workplan: prev });
      alert("Could not update: " + (e.response?.data?.detail || e.message));
    }
  };

  if (nodes.length === 0) {
    return (
      <div className="wp-empty-note" data-testid="wp-empty">
        No workplan yet. It seeds automatically on the next backend boot.
      </div>
    );
  }

  return (
    <div data-testid="workplan">
      <div className="wp-toolbar">
        <div className="wp-seg" data-testid="wp-view-toggle">
          {VIEWS.map((v) => (
            <button
              key={v.key}
              className={view === v.key ? "on" : ""}
              onClick={() => setView(v.key)}
              data-testid={`wp-view-${v.key}`}
            >
              <span className="wp-seg-icon" aria-hidden="true">{v.icon}</span>
              {v.label}
            </button>
          ))}
        </div>
      </div>

      {view === "list" && (
        <WorkplanList tree={tree} nodes={nodes} isAdmin={isAdmin} onStatus={onStatus} showDoneWhen />
      )}
      {view === "board" && <WorkplanBoard nodes={nodes} isAdmin={isAdmin} onStatus={onStatus} />}
      {view === "owner" && <WorkplanOwner nodes={nodes} isAdmin={isAdmin} onStatus={onStatus} />}
      {view === "timeline" && <WorkplanTimeline tree={tree} nodes={nodes} weeks={weeks} />}
    </div>
  );
}
